export type GameScoreKey = "matching" | "restorationOne" | "restorationTwo" | "paintingOne" | "paintingTwo" | "rings" | "escape";

const GAME_SCORES_STORAGE_KEY = "mariaffi-game-scores";

type GameScores = Partial<Record<GameScoreKey, number>>;

function readScores(): GameScores {
  try {
    const storedScores = localStorage.getItem(GAME_SCORES_STORAGE_KEY);
    return storedScores ? JSON.parse(storedScores) as GameScores : {};
  } catch {
    return {};
  }
}

export function getGameScore(game: GameScoreKey) {
  return readScores()[game] ?? 0;
}

export function saveGameScore(game: GameScoreKey, score: number) {
  const scores = readScores();
  const bestScore = Math.max(scores[game] ?? 0, score);

  try {
    localStorage.setItem(GAME_SCORES_STORAGE_KEY, JSON.stringify({
      ...scores,
      [game]: bestScore,
    }));
  } catch {
    // The game remains usable when browser storage is unavailable.
  }

  return bestScore;
}
